import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=3af5f842&scoped=true&"
import script from "./NewsManage.vue?vue&type=script&lang=js&"
export * from "./NewsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5f842",
  null
  
)

export default component.exports